import Loading from '@/components/common/Loading.vue'

let loadingInstance = null

const LoadingPlugin = {
  install(Vue) {
    // 创建loading构造器
    const LoadingConstructor = Vue.extend(Loading)

    // 创建loading实例方法
    const createLoadingInstance = () => {
      const instance = new LoadingConstructor({
        vuetify: Vue.prototype.$vuetify
      })

      // 挂载到body
      const vm = instance.$mount()
      document.body.appendChild(vm.$el)

      return instance
    }

    // 显示loading
    const show = message => {
      if (!loadingInstance) {
        loadingInstance = createLoadingInstance()
      }
      loadingInstance.showLoading(message)
    }

    // 隐藏loading
    const hide = () => {
      if (loadingInstance) {
        loadingInstance.hide()
      }
    }

    // 添加到Vue原型
    Vue.prototype.$loading = {
      show,
      hide
    }

    // 添加到全局
    Vue.loading = {
      show,
      hide
    }
  }
}

export default LoadingPlugin
